/* ============================================================
   Celyssia — ShapeLift
   Quiz de taille, sélecteur Tour de dos / Bonnet, tuiles de
   combinaison et photo de bundle.

   Ce fichier ne concerne QUE ShapeLift.
   Le tableau des tailles est recopié cellule par cellule du guide
   officiel ShapeLift. Les tirets du guide sont volontairement
   absents de ce tableau : la combinaison n'existe pas, et le code
   doit le dire, pas l'inventer.
   Ne pas réutiliser tel quel sur un autre produit.
   ============================================================ */

const MB_PRODUCT = {
    match: ["shapelift"],
    label: "ShapeLift",
    bands: ["80", "85", "90", "95", "100", "105", "110", "115", "120", "125"],
    cups:  ["A", "B", "C", "D", "E", "F", "G", "H"],

    /* Image affichée dans la fenêtre « Guide des tailles ».
       Shopify > Contenu > Fichiers, on téléverse, on copie l'URL
       et on la colle ici. C'est le seul endroit à modifier.
       Laissé vide, la fenêtre affiche à la place le tableau
       construit depuis map (plus bas). Rien ne casse, et le
       tableau reste lisible au téléphone. */
    guideImage: "https://cdn.shopify.com/s/files/1/0783/0978/5927/files/NEW_SHAPELIFT_FR.jpg?v=1789089925",

    /* Le guide ShapeLift l'indique noir sur blanc : entre deux
       tailles, on prend la plus petite. */
    rounding: "down",
    roundingText: "Entre deux tailles, prenez la plus petite.",

    /* Une ligne par bonnet, dans l'ordre du guide. */
    map: {
      "80A":"S", "85A":"S", "90A":"S",  "95A":"M",  "100A":"L",   "105A":"L",
      "80B":"S", "85B":"S", "90B":"S",  "95B":"M",  "100B":"L",   "105B":"L",   "110B":"XL",  "115B":"2XL", "120B":"2XL", "125B":"3XL",
      "80C":"S", "85C":"S", "90C":"M",  "95C":"M",  "100C":"L",   "105C":"XL",  "110C":"2XL", "115C":"2XL", "120C":"3XL", "125C":"3XL",
      "80D":"S", "85D":"M", "90D":"M",  "95D":"L",  "100D":"XL",  "105D":"XL",  "110D":"2XL", "115D":"3XL", "120D":"3XL", "125D":"4XL",
      "80E":"M", "85E":"M", "90E":"L",  "95E":"L",  "100E":"XL",  "105E":"2XL", "110E":"2XL", "115E":"3XL", "120E":"4XL", "125E":"4XL",
      "80F":"M", "85F":"M", "90F":"L",  "95F":"XL", "100F":"XL",  "105F":"2XL", "110F":"3XL", "115F":"3XL", "120F":"4XL", "125F":"4XL",
                            "90G":"L",  "95G":"XL", "100G":"2XL", "105G":"3XL", "110G":"3XL", "115G":"4XL", "120G":"4XL", "125G":"4XL",
                            "90H":"L",  "95H":"XL", "100H":"3XL", "105H":"3XL", "110H":"3XL", "115H":"4XL", "120H":"4XL"
    }
  };

const BRA_SIZE_MAP = MB_PRODUCT.map;
const BAND_OPTIONS = MB_PRODUCT.bands;
const CUP_OPTIONS  = MB_PRODUCT.cups;

const MB_COLOURS = {
  "Noir":   "#0F0F0F",
  "Blanc":  "#FFFFFF",
  "Beige":  "#EFEEDA",
  "Marron": "#43312A",
  "Rose":   "#C9A399"
};

const MB_COMBOS = {
  2: [
    ["Noir", "Blanc"],
    ["Noir", "Beige"],
    ["Blanc", "Beige"],
    ["Noir", "Rose"],
    ["Marron", "Rose"],
    ["Noir", "Noir"],
    ["Blanc", "Blanc"],
    ["Beige", "Beige"],
    ["Marron", "Marron"],
    ["Rose", "Rose"]
  ],
  3: [
    ["Noir", "Blanc", "Beige"],
    ["Noir", "Marron", "Rose"],
    ["Noir", "Noir", "Noir"],
    ["Blanc", "Blanc", "Blanc"],
    ["Beige", "Beige", "Beige"],
    ["Marron", "Marron", "Marron"],
    ["Rose", "Rose", "Rose"]
  ]
};

/* Photo shown when a combination is selected.
   ATTENTION : ces URLs sont celles reprises de ShapeLift / LaceLift.
   A remplacer par les photos de bundle ShapeLift, sinon la galerie
   affiche un autre modele que celui de la page.
   Key = the colours in the same order as in MB_COMBOS, joined by "|".
   Upload photos to Shopify > Content > Files, then paste the CDN URLs.
   Any combo left out simply shows no photo. */
const MB_COMBO_IMAGES = {
  "Noir|Blanc":  "https://cdn.shopify.com/s/files/1/0783/0978/5927/files/19_29bc1d3b-6e32-42ac-9358-c08b5943ce7f.jpg?v=1787020372",
  "Noir|Beige":  "https://cdn.shopify.com/s/files/1/0783/0978/5927/files/20_9506816a-0900-43e3-ad1d-17db493fc63e.jpg?v=1787020372",
  "Blanc|Beige": "https://cdn.shopify.com/s/files/1/0783/0978/5927/files/21_5d1417d2-114a-46bd-9fa6-4079ecaf7f78.jpg?v=1787020373",
  "Noir|Rose":   "https://cdn.shopify.com/s/files/1/0783/0978/5927/files/22_47fcb0cf-d2db-46f8-b92f-7fdef9c9b16b.jpg?v=1787020372",
  "Marron|Rose": "https://cdn.shopify.com/s/files/1/0783/0978/5927/files/23_4544a97a-05ff-4b36-ac89-762fd856c93f.jpg?v=1787020373",
  "Noir|Noir":   "",
  "Blanc|Blanc": "",
  "Beige|Beige": "",
  "Marron|Marron": "",
  "Rose|Rose":   "",

  "Noir|Blanc|Beige":    "https://cdn.shopify.com/s/files/1/0783/0978/5927/files/SHAPELIFT_17.jpg?v=1787023310",
  "Noir|Marron|Rose":    "https://cdn.shopify.com/s/files/1/0783/0978/5927/files/SHAPELIFT_18.jpg?v=1787023310",
  "Noir|Noir|Noir":      "",
  "Blanc|Blanc|Blanc":   "",
  "Beige|Beige|Beige":   "",
  "Marron|Marron|Marron": "",
  "Rose|Rose|Rose":      ""
};

/* Where the combination photo is shown.
   "gallery" = the theme's main product image on the left
   "inline"  = a photo inside the bundle widget
   "both"    = both */
const MB_PHOTO_TARGET = "gallery";

let isUpdating = false;
let listboxHider = null;
let mbCurrentOverlayUrl = "";

/* Dernière taille appliquée (quiz ou choix manuel). Sert à remettre
   la même taille sur une offre que Moon Bundle reconstruit ensuite,
   par exemple quand la cliente passe du lot de 2 au lot de 3. */
const MB_QUIZ_APPLIED = { band: "", cup: "" };

function wait(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function waitFor(fn, timeout, interval) {
  const max = timeout || 600;
  const step = interval || 16;
  return new Promise(resolve => {
    const start = Date.now();
    (function check() {
      const result = fn();
      if (result) return resolve(result);
      if (Date.now() - start >= max) return resolve(null);
      setTimeout(check, step);
    })();
  });
}

function normalizeText(text) {
  return (text || "").replace(/\s+/g, " ").trim().toUpperCase();
}

function hideListboxNode(node) {
  if (!node || node.nodeType !== 1) return;
  const isList =
    (node.matches && node.matches('[role="listbox"], [role="option"], .moonbundle-dropdown-item')) ||
    (node.querySelector && node.querySelector('[role="option"], .moonbundle-dropdown-item'));
  if (!isList) return;
  node.style.setProperty("visibility", "hidden", "important");
  node.style.setProperty("opacity", "0", "important");
  node.style.setProperty("pointer-events", "none", "important");
}

function startHidingListboxes() {
  if (listboxHider) return;
  document.querySelectorAll('[role="listbox"]').forEach(hideListboxNode);
  listboxHider = new MutationObserver(mutations => {
    for (const m of mutations) {
      m.addedNodes.forEach(hideListboxNode);
    }
  });
  listboxHider.observe(document.body, { childList: true, subtree: true });
}

function stopHidingListboxes() {
  if (!listboxHider) return;
  listboxHider.disconnect();
  listboxHider = null;
}

function injectStyles() {
  if (document.getElementById("mb-bra-global-styles")) return;

  const style = document.createElement("style");
  style.id = "mb-bra-global-styles";
  style.textContent = `
    .mb-global-bra-ui{
      position:relative;
      width:100%;
      margin:12px 0 0;
      padding:12px;
      border:1px solid rgba(0,0,0,.14);
      border-radius:12px;
      background:#EAC8BA;
      box-sizing:border-box;
    }

    .mb-global-size-guide-link{
      position:absolute;
      top:12px;
      right:12px;
      z-index:5;
      background:none;
      border:none;
      padding:0;
      margin:0;
      font-size:12px;
      font-weight:600;
      text-decoration:underline;
      cursor:pointer;
      color:#111;
      line-height:1;
    }

    .mb-global-bra-title{
      font-size:14px;
      font-weight:700;
      color:#111;
      line-height:1.2;
      margin-bottom:10px;
      padding-right:120px;
    }

    .mb-global-bra-grid{
      display:grid;
      grid-template-columns:1fr 1fr;
      gap:8px;
      width:100%;
    }

    .mb-global-bra-field{
      position:relative;
      display:flex;
      flex-direction:column;
      gap:4px;
      min-width:0;
    }

    .mb-global-bra-label{
      font-size:11px;
      font-weight:600;
      color:#111;
      line-height:1.2;
    }

    .mb-global-bra-field select{
      width:100%;
      height:36px;
      border:1px solid #111;
      border-radius:8px;
      background:#fff;
      color:#111;
      padding:0 28px 0 10px;
      font-size:13px;
      font-weight:500;
      outline:none;
      appearance:none;
      -webkit-appearance:none;
      box-shadow:none;
      cursor:pointer;
    }

    .mb-global-bra-field::after{
      content:"";
      position:absolute;
      right:10px;
      bottom:13px;
      width:10px;
      height:10px;
      pointer-events:none;
      background:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath fill='%23000' d='M6 9L1 4h10z'/%3E%3C/svg%3E") no-repeat center;
      background-size:contain;
    }

    .mb-recommended-size-slot{
      display:flex;
      flex-direction:column;
      gap:7px;
      margin-top:10px;
    }

    .mb-size-row{
      display:grid;
      grid-template-columns:26px 1fr;
      align-items:center;
      gap:8px;
      width:100%;
    }

    .mb-size-row-label{
      font-size:12px;
      font-weight:700;
      color:#111;
      opacity:.8;
    }

    .mb-size-row .moonbundle-option-selector{
      width:100% !important;
    }

    .mb-size-row .moonbundle-option-name{
      display:none !important;
    }

    .mb-size-row .moonbundle-dropdown-button{
      width:100% !important;
      height:34px !important;
      min-height:34px !important;
      border-radius:8px !important;
      background:#fff !important;
      position:relative;
      overflow:hidden;
    }

    .mb-global-bra-error{
      color:#b42318;
      font-weight:600;
      font-size:12px;
      margin-top:8px;
    }

    .moonbundle-variant-row{
      margin-bottom:10px !important;
    }

    .moonbundle-variant-selectors{
      display:block !important;
      width:100% !important;
    }

    .moonbundle-swatch-buttons{
      display:flex !important;
      gap:8px !important;
      flex-wrap:wrap !important;
      align-items:center !important;
    }

    .moonbundle-variant-row .moonbundle-variant-selectors > div:nth-child(2):empty{
      display:none !important;
    }

    body.mb-bra-syncing .mb-recommended-size-slot .moonbundle-dropdown-button{
      pointer-events:none;
    }

    body.mb-bra-syncing .mb-recommended-size-slot .moonbundle-dropdown-selected span{
      visibility:hidden;
    }

    body.mb-bra-syncing .mb-recommended-size-slot .moonbundle-dropdown-button::after{
      content:"";
      position:absolute;
      inset:0;
      background:linear-gradient(90deg,transparent,rgba(0,0,0,.07),transparent);
      animation:mb-bra-shimmer .8s linear infinite;
    }

    @keyframes mb-bra-shimmer{
      from{transform:translateX(-100%);}
      to{transform:translateX(100%);}
    }

    .mb-size-guide-modal{
      position:fixed;
      inset:0;
      display:none;
      z-index:99999;
    }

    .mb-size-guide-modal.active{
      display:block;
    }

    .mb-size-guide-overlay{
      position:absolute;
      inset:0;
      background:rgba(0,0,0,.6);
    }

    .mb-size-guide-box{
      position:absolute;
      top:50%;
      left:50%;
      transform:translate(-50%, -50%);
      width:92%;
      max-width:540px;
    }

    .mb-size-guide-content{
      max-height:86vh;
      overflow:auto;
      border-radius:12px;
      background:#FBF9F7;
      -webkit-overflow-scrolling:touch;
    }

    .mb-size-guide-box img{
      display:block;
      width:100%;
      border-radius:12px;
    }

    .mb-size-guide-table{
      padding:18px 16px 16px;
      font-family:inherit;
      color:#1C1310;
    }

    .mb-size-guide-table h3{
      margin:0 0 6px;
      padding-right:40px;
      font-size:16px;
      font-weight:700;
      line-height:1.25;
    }

    .mb-size-guide-table .mb-sg-sub{
      margin:0 0 12px;
      font-size:12.5px;
      line-height:1.45;
      color:#6B5A52;
    }

    .mb-size-guide-table .mb-sg-hint{
      margin:0 0 10px;
      font-size:12px;
      font-style:italic;
      color:#8A7168;
    }

    .mb-sg-scroll{
      overflow-x:auto;
      -webkit-overflow-scrolling:touch;
    }

    .mb-size-guide-table table{
      width:100%;
      border-collapse:separate;
      border-spacing:4px;
    }

    .mb-size-guide-table th,
    .mb-size-guide-table td{
      padding:8px 5px;
      border-radius:6px;
      font-size:12px;
      font-weight:700;
      text-align:center;
      white-space:nowrap;
      color:#fff;
      background:#A9695A;
    }

    .mb-size-guide-table thead th{
      background:#5E2F26;
    }

    .mb-size-guide-table .mb-sg-cup{
      background:#C08877;
    }

    .mb-size-guide-table .mb-sg-corner{
      min-width:62px;
      background:#5E2F26;
      font-size:10px;
      line-height:1.2;
      white-space:normal;
    }

    .mb-size-guide-table .mb-sg-empty{
      background:#EFE4DF;
      color:#BCA9A2;
    }

    .mb-size-guide-close{
      position:absolute;
      top:8px;
      right:8px;
      width:32px;
      height:32px;
      border:none;
      border-radius:999px;
      background:rgba(0,0,0,.75);
      color:#fff;
      font-size:20px;
      line-height:1;
      cursor:pointer;
      z-index:2;
    }

    @media (max-width:640px){
      .mb-global-bra-field select{
        height:34px;
        font-size:12px;
      }

      .mb-global-size-guide-link{
        font-size:11px;
        top:12px;
        right:12px;
      }

      .mb-global-bra-title{
        padding-right:105px;
      }
    }
  `;
  document.head.appendChild(style);
}

function mbInjectComboStyles() {
  if (document.getElementById("mb-combo-styles")) return;

  const style = document.createElement("style");
  style.id = "mb-combo-styles";
  style.textContent = `
    .mb-combo-mode .moonbundle-variant-row{
      height:0 !important;
      overflow:hidden !important;
      opacity:0 !important;
      pointer-events:none;
      margin:0 !important;
      padding:0 !important;
    }

    .mb-combo-heading{
      font-size:12px;
      color:#4A342C;
      margin:0 0 6px;
      line-height:1.2;
    }

    .mb-gallery-overlay{
      position:absolute;
      inset:0;
      width:100%;
      height:100%;
      object-fit:cover;
      z-index:3;
      border-radius:inherit;
      pointer-events:none;
      animation:mb-overlay-in .18s ease both;
    }

    @keyframes mb-overlay-in{
      from{opacity:0;}
      to{opacity:1;}
    }

    .mb-combo-photo{
      display:none;
      width:100%;
      aspect-ratio:1 / 1;
      object-fit:cover;
      border-radius:12px;
      margin:0 0 10px;
      background:rgba(0,0,0,.04);
      opacity:0;
      transition:opacity .18s ease;
    }

    .mb-combo-photo.is-visible{
      display:block;
      opacity:1;
    }

    .mb-combo-grid{
      display:flex;
      flex-wrap:wrap;
      gap:10px;
      align-items:center;
      margin:0 0 14px;
    }

    .mb-combo-tile{
      appearance:none;
      background:none;
      border:0;
      padding:0;
      margin:0;
      cursor:pointer;
      line-height:0;
      font:inherit;
    }

    .mb-combo-swatch{
      display:flex;
      width:var(--mb-sw-size, 30px);
      height:var(--mb-sw-size, 30px);
      border-radius:var(--mb-sw-radius, 8px);
      overflow:hidden;
      border:1.5px solid #CFC8C2;
      box-sizing:border-box;
      transition:border-color .12s ease;
    }

    .mb-combo-swatch i{
      flex:1;
      display:block;
    }

    .mb-combo-label{
      position:absolute;
      width:1px; height:1px;
      overflow:hidden;
      clip:rect(0 0 0 0);
      white-space:nowrap;
    }

    .mb-combo-tile[aria-pressed="true"] .mb-combo-swatch{
      border-color:#111;
      border-width:2.5px;
    }

    .mb-combo-tile:focus-visible .mb-combo-swatch{
      outline:2px solid #111;
      outline-offset:3px;
    }

    @media (max-width:640px){
      .mb-combo-grid{ gap:8px; }
    }
  `;
  document.head.appendChild(style);
}

/* Tableau des tailles construit depuis MB_PRODUCT.
   C'est le filet de sécurité du guide : même sans image, la cliente
   voit les tailles, et au téléphone le texte reste net. */
function mbSizeGuideTableHtml() {
  const bands = MB_PRODUCT.bands;
  const cups = MB_PRODUCT.cups;
  let holes = false;

  let head = '<tr><th class="mb-sg-corner">Bonnet / Tour de dos</th>';
  bands.forEach(function (b) {
    head += '<th>' + b + '</th>';
  });
  head += '</tr>';

  let rows = '';
  cups.forEach(function (c) {
    rows += '<tr><th class="mb-sg-cup">' + c + '</th>';
    bands.forEach(function (b) {
      const v = BRA_SIZE_MAP[b + c];
      if (v) {
        rows += '<td>' + v + '</td>';
      } else {
        holes = true;
        rows += '<td class="mb-sg-empty">\u2014</td>';
      }
    });
    rows += '</tr>';
  });

  let notes = 'Votre tour de dos en haut, votre bonnet \u00e0 gauche. La case au croisement donne votre taille.';
  if (holes) notes += ' Un tiret veut dire que cette taille n\u2019existe pas sur ce mod\u00e8le.';
  if (MB_PRODUCT.roundingText) notes += ' ' + MB_PRODUCT.roundingText;

  const hint = bands.length > 8
    ? '<p class="mb-sg-hint">Faites glisser le tableau pour voir tous les tours de dos.</p>'
    : '';

  return '<div class="mb-size-guide-table">' +
    '<h3>' + MB_PRODUCT.label + ' \u2014 Guide des tailles</h3>' +
    '<p class="mb-sg-sub">' + notes + '</p>' +
    hint +
    '<div class="mb-sg-scroll"><table><thead>' + head + '</thead>' +
    '<tbody>' + rows + '</tbody></table></div>' +
    '</div>';
}

function injectSizeGuideModal() {
  if (document.getElementById("mb-size-guide-modal")) return;

  const modal = document.createElement("div");
  modal.id = "mb-size-guide-modal";
  modal.className = "mb-size-guide-modal";
  modal.innerHTML = `
    <div class="mb-size-guide-overlay"></div>
    <div class="mb-size-guide-box">
      <button type="button" class="mb-size-guide-close" aria-label="Fermer">×</button>
      <div class="mb-size-guide-content"></div>
    </div>
  `;
  document.body.appendChild(modal);

  /* L'image officielle si elle est renseignée, le tableau sinon.
     Si l'URL est fausse ou l'image introuvable, on bascule aussi sur
     le tableau : la fenêtre ne s'ouvre jamais sur du vide. */
  const content = modal.querySelector(".mb-size-guide-content");

  if (MB_PRODUCT.guideImage) {
    const img = document.createElement("img");
    img.alt = "Guide des tailles " + MB_PRODUCT.label;
    img.addEventListener("error", function () {
      content.innerHTML = mbSizeGuideTableHtml();
    });
    img.src = MB_PRODUCT.guideImage;
    content.appendChild(img);
  } else {
    content.innerHTML = mbSizeGuideTableHtml();
  }

  modal.querySelector(".mb-size-guide-close").addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    modal.classList.remove("active");
  });

  modal.querySelector(".mb-size-guide-overlay").addEventListener("click", function () {
    modal.classList.remove("active");
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") modal.classList.remove("active");
  });
}

function openSizeGuideModal(e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  const modal = document.getElementById("mb-size-guide-modal");
  if (modal) modal.classList.add("active");
}

function findOption(dropdownRoot, targetValue) {
  const target = normalizeText(targetValue);
  const scoped = Array.from(
    dropdownRoot.querySelectorAll('[role="option"], .moonbundle-dropdown-item')
  );
  let match = scoped.find(el => normalizeText(el.textContent) === target);
  if (match) return match;

  const global = Array.from(
    document.querySelectorAll('[role="option"], .moonbundle-dropdown-item')
  );
  return global.find(el => normalizeText(el.textContent) === target) || null;
}

function readMoonbundleDropdownValue(dropdownRoot) {
  if (!dropdownRoot) return "";
  const span = dropdownRoot.querySelector(".moonbundle-dropdown-selected span");
  return normalizeText(span && span.textContent);
}

async function selectMoonbundleDropdownValue(dropdownRoot, targetValue) {
  if (!dropdownRoot || !targetValue) return false;

  const button = dropdownRoot.querySelector(".moonbundle-dropdown-button");
  if (!button) return false;

  const target = normalizeText(targetValue);
  const getCurrent = () => readMoonbundleDropdownValue(dropdownRoot);

  if (getCurrent() === target) return true;

  button.click();

  const match = await waitFor(() => findOption(dropdownRoot, targetValue), 600, 16);

  if (!match) {
    document.body.click();
    return false;
  }

  match.click();

  await waitFor(() => getCurrent() === target, 400, 16);

  return getCurrent() === target;
}

function getVariantRowsFromOffer(offer) {
  if (!offer) return [];
  return Array.from(offer.querySelectorAll(".moonbundle-variant-row"));
}

function moveAllSizeSelectorsIntoBox(offer) {
  const slot = offer.querySelector(".mb-recommended-size-slot");
  if (!slot) return;

  const rows = getVariantRowsFromOffer(offer);
  if (!rows.length) return;

  rows.forEach((row, index) => {
    if (slot.querySelector(`[data-mb-size-row="${index + 1}"]`)) return;

    const selectors = row.querySelectorAll(".moonbundle-option-selector");
    if (selectors.length < 2) return;

    const sizeSelector = selectors[selectors.length - 1];
    sizeSelector.classList.add("mb-moved-size-selector");

    const wrapper = document.createElement("div");
    wrapper.className = "mb-size-row";
    wrapper.setAttribute("data-mb-size-row", String(index + 1));

    const label = document.createElement("div");
    label.className = "mb-size-row-label";
    label.textContent = `#${index + 1}`;

    wrapper.appendChild(label);
    wrapper.appendChild(sizeSelector);
    slot.appendChild(wrapper);
  });
}

function mbLockScroll(duration) {
  const x = window.scrollX;
  const y = window.scrollY;
  let stop = false;

  const hold = () => {
    if (window.scrollX !== x || window.scrollY !== y) {
      window.scrollTo(x, y);
    }
    if (!stop) requestAnimationFrame(hold);
  };

  requestAnimationFrame(hold);
  setTimeout(() => { stop = true; }, duration || 700);
}

/* Renvoie true quand chaque exemplaire de l'offre affiche bien la
   taille produit correspondant à band+cup, false sinon (ou si un
   autre passage était encore en cours). Le quiz s'appuie sur ce
   retour pour vérifier, pas seulement pour lancer. */
async function applyMappedSizeToOffer(offer, band, cup, errorEl) {
  if (!offer || isUpdating) return false;

  isUpdating = true;
  mbLockScroll(1200);
  document.body.classList.add("mb-bra-syncing");
  startHidingListboxes();

  try {
    if (errorEl) errorEl.innerHTML = "";

    if (!band || !cup) return false;

    const mappedSize = BRA_SIZE_MAP[`${band}${cup}`];

    if (!mappedSize) {
      if (errorEl) {
        errorEl.innerHTML = `<span class="mb-global-bra-error">Cette taille n’existe pas sur ce modèle. Le quiz vous indique la plus proche.</span>`;
      }
      return false;
    }

    moveAllSizeSelectorsIntoBox(offer);

    const dropdowns = Array.from(
      offer.querySelectorAll(".mb-recommended-size-slot .moonbundle-custom-dropdown")
    );

    let allOk = dropdowns.length > 0;

    for (const dropdown of dropdowns) {
      let ok = await selectMoonbundleDropdownValue(dropdown, mappedSize);

      /* Moon Bundle peut refermer la liste ou reconstruire la ligne
         entre deux clics : un second essai suffit en général. */
      if (!ok) {
        await wait(120);
        ok = await selectMoonbundleDropdownValue(dropdown, mappedSize);
      }

      if (!ok) allOk = false;
    }

    if (!allOk && errorEl) {
      errorEl.innerHTML = `<span class="mb-global-bra-error">Impossible de sélectionner la taille automatiquement, choisissez-la ci-dessous</span>`;
    }

    return allOk;
  } finally {
    stopHidingListboxes();
    document.body.classList.remove("mb-bra-syncing");
    isUpdating = false;
  }
}

function buildGlobalSelectorUI(offer) {
  const ui = document.createElement("div");
  ui.className = "mb-global-bra-ui";

  ui.innerHTML = `
    <button type="button" class="mb-global-size-guide-link">Guide des tailles</button>
    <div class="mb-global-bra-title">Choisissez votre taille</div>

    <div class="mb-global-bra-grid">
      <div class="mb-global-bra-field">
        <div class="mb-global-bra-label">Tour de dos</div>
        <select class="mb-global-band">
          <option value="">Tour de dos</option>
          ${BAND_OPTIONS.map(v => `<option value="${v}">${v}</option>`).join("")}
        </select>
      </div>

      <div class="mb-global-bra-field">
        <div class="mb-global-bra-label">Bonnet</div>
        <select class="mb-global-cup">
          <option value="">Bonnet</option>
          ${CUP_OPTIONS.map(v => `<option value="${v}">${v}</option>`).join("")}
        </select>
      </div>
    </div>

    <div class="mb-recommended-size-slot"></div>
    <div class="mb-global-bra-error-wrap"></div>
  `;

  const bandSelect = ui.querySelector(".mb-global-band");
  const cupSelect = ui.querySelector(".mb-global-cup");
  const errorEl = ui.querySelector(".mb-global-bra-error-wrap");
  const sizeGuideBtn = ui.querySelector(".mb-global-size-guide-link");

  const onChange = () => {
    /* Un choix manuel remplace le résultat du quiz pour la suite. */
    if (bandSelect.value && cupSelect.value) {
      MB_QUIZ_APPLIED.band = bandSelect.value;
      MB_QUIZ_APPLIED.cup = cupSelect.value;
    }
    applyMappedSizeToOffer(offer, bandSelect.value, cupSelect.value, errorEl);
  };

  bandSelect.addEventListener("change", onChange);
  cupSelect.addEventListener("change", onChange);
  sizeGuideBtn.addEventListener("click", openSizeGuideModal);

  return ui;
}

function injectGlobalSelectorIntoOffer(offer) {
  if (!offer || offer.querySelector(".mb-global-bra-ui")) return;

  const variantsBox = offer.querySelector(".moonbundle-variants-box");
  if (!variantsBox) return;

  const rows = getVariantRowsFromOffer(offer);
  if (!rows.length) return;

  const ui = buildGlobalSelectorUI(offer);

  variantsBox.appendChild(ui);
  moveAllSizeSelectorsIntoBox(offer);
}

function mbComboLabel(combo) {
  const unique = Array.from(new Set(combo));
  if (unique.length === 1) return combo.length + "\u00D7 " + unique[0];
  if (combo.length === 3 && unique.length === 3 &&
      unique.join(" + ") === "Noir + Blanc + Beige") return "Multicolore";
  return unique.join(" + ");
}

function mbNormaliseColour(value) {
  return (value || "").replace(/\s+/g, " ").trim().toLowerCase();
}

function mbRgbToHex(rgb) {
  const m = (rgb || "").match(/\d+/g);
  if (!m || m.length < 3) return "";
  return "#" + m.slice(0, 3)
    .map(n => Number(n).toString(16).padStart(2, "0"))
    .join("").toUpperCase();
}

function mbFindColourControl(row, colourName) {
  const target = mbNormaliseColour(colourName);
  const hex = (MB_COLOURS[colourName] || "").toUpperCase();

  const selectors = row.querySelectorAll(".moonbundle-option-selector");
  const scope = selectors.length ? selectors[0] : row;

  const candidates = Array.from(
    scope.querySelectorAll('button, [role="option"], [role="radio"], .moonbundle-swatch, .moonbundle-dropdown-item')
  );

  for (const el of candidates) {
    const labels = [
      el.getAttribute("data-value"),
      el.getAttribute("data-option-value"),
      el.getAttribute("aria-label"),
      el.getAttribute("title"),
      el.textContent
    ];
    if (labels.some(l => mbNormaliseColour(l) === target)) return el;
  }

  if (hex) {
    for (const el of candidates) {
      if (mbRgbToHex(getComputedStyle(el).backgroundColor) === hex) return el;
      const inner = el.querySelector("span, i, div");
      if (inner && mbRgbToHex(getComputedStyle(inner).backgroundColor) === hex) return el;
    }
  }

  return null;
}

async function mbApplyCombo(offer, combo) {
  const rows = getVariantRowsFromOffer(offer);

  for (let i = 0; i < combo.length && i < rows.length; i++) {
    const control = mbFindColourControl(rows[i], combo[i]);
    if (!control) continue;

    const dropdown = rows[i].querySelector(".moonbundle-custom-dropdown");
    if (dropdown && dropdown.contains(control)) {
      await selectMoonbundleDropdownValue(dropdown, combo[i]);
    } else {
      if (typeof control.focus === "function") {
        try { control.focus({ preventScroll: true }); } catch (e) {}
      }
      control.click();
      if (typeof control.blur === "function") control.blur();
    }
    await wait(40);
  }
}

function mbComboKey(combo) {
  return combo.join("|");
}

/* Built once from MB_COMBO_IMAGES so the order of colours in a key
   never has to match the order of colours in MB_COMBOS. */
let mbImageLookup = null;

function mbBuildImageLookup() {
  if (mbImageLookup) return mbImageLookup;

  mbImageLookup = {};
  Object.keys(MB_COMBO_IMAGES).forEach(key => {
    const url = MB_COMBO_IMAGES[key];
    if (!url) return;
    const sorted = key.split("|").map(s => s.trim()).sort().join("|");
    if (!mbImageLookup[sorted]) mbImageLookup[sorted] = url;
  });

  return mbImageLookup;
}

function mbComboImage(combo) {
  const exact = MB_COMBO_IMAGES[mbComboKey(combo)];
  if (exact) return exact;

  const sorted = combo.slice().sort().join("|");
  return mbBuildImageLookup()[sorted] || "";
}

function mbPreloadComboImages(combos) {
  combos.forEach(combo => {
    const url = mbComboImage(combo);
    if (url) new Image().src = url + (url.indexOf("?") === -1 ? "?" : "&") + "width=1200";
  });
}

function mbFindGalleryImage() {
  const scopes = document.querySelectorAll(
    'media-gallery, product-media-gallery, .product-media-gallery, ' +
    '.product__media-wrapper, .product-media-container, .product__media-list, ' +
    '[class*="product-gallery"], [class*="product__media"]'
  );

  let best = null;
  let bestArea = 0;

  scopes.forEach(scope => {
    scope.querySelectorAll("img").forEach(img => {
      const r = img.getBoundingClientRect();
      const area = r.width * r.height;
      /* Skip thumbnails and anything hidden. */
      if (r.width < 200 || area <= bestArea) return;
      best = img;
      bestArea = area;
    });
  });

  return best;
}

/* The overlay must sit on the slider viewport, not on one slide.
   Walk up from the image while the ancestor is still roughly the same
   height, which lands on the visible frame rather than the track. */
function mbFindGalleryHost(img) {
  let node = img.parentElement;
  let best = node;
  const baseH = img.getBoundingClientRect().height || 1;

  for (let i = 0; i < 6 && node && node !== document.body; i++) {
    const r = node.getBoundingClientRect();
    if (r.height > baseH * 1.4 || r.width < 100) break;
    best = node;
    node = node.parentElement;
  }

  return best;
}

let mbOverlayBound = false;

function mbRemoveGalleryOverlay() {
  document.querySelectorAll(".mb-gallery-overlay").forEach(el => el.remove());
}

/* Any interaction with the gallery hands control straight back to the
   theme, so the slider is never left in an inconsistent state. */
function mbBindGalleryHandoff() {
  if (mbOverlayBound) return;
  mbOverlayBound = true;

  const release = () => {
    mbCurrentOverlayUrl = "";
    mbRemoveGalleryOverlay();
  };

  ["pointerdown", "wheel", "touchmove", "keydown"].forEach(type => {
    document.addEventListener(type, e => {
      const overlay = document.querySelector(".mb-gallery-overlay");
      if (!overlay) return;

      const scope = overlay.parentElement;
      if (!scope) return;

      /* Only release when the interaction is in or near the gallery. */
      if (type === "keydown" || (e.target && scope.contains(e.target))) {
        release(e);
      }
    }, { passive: true, capture: true });
  });
}

function mbPlaceGalleryOverlay(url) {
  const img = mbFindGalleryImage();
  if (!img) return;

  const host = mbFindGalleryHost(img);
  if (!host) return;

  let overlay = host.querySelector(":scope > .mb-gallery-overlay");

  if (!overlay) {
    /* Drop any overlay left on a slide the theme has scrolled away. */
    mbRemoveGalleryOverlay();

    if (getComputedStyle(host).position === "static") {
      host.style.position = "relative";
    }

    overlay = document.createElement("img");
    overlay.className = "mb-gallery-overlay";
    overlay.decoding = "async";
    host.appendChild(overlay);
  }

  if (overlay.getAttribute("src") !== url) {
    overlay.setAttribute("src", url);
  }
}

function mbSetGalleryPhoto(url) {
  mbBindGalleryHandoff();

  if (!url) {
    mbCurrentOverlayUrl = "";
    mbRemoveGalleryOverlay();
    return;
  }

  const sized = url + (url.indexOf("?") === -1 ? "?" : "&") + "width=1200";
  mbCurrentOverlayUrl = sized;

  mbPlaceGalleryOverlay(sized);

  /* Selecting a variant makes the theme slide to that colour's photo,
     which can detach the overlay. Re-place it once things settle. */
  [120, 350, 700].forEach(delay => {
    setTimeout(() => {
      if (mbCurrentOverlayUrl === sized) mbPlaceGalleryOverlay(sized);
    }, delay);
  });
}

function mbShowComboPhoto(offer, combo) {
  const url = mbComboImage(combo);

  if (MB_PHOTO_TARGET === "gallery" || MB_PHOTO_TARGET === "both") {
    mbSetGalleryPhoto(url);
  }

  if (MB_PHOTO_TARGET === "inline" || MB_PHOTO_TARGET === "both") {
    const photo = offer.querySelector(".mb-combo-photo");
    if (!photo) return;

    if (!url) {
      photo.classList.remove("is-visible");
      photo.removeAttribute("src");
      return;
    }

    photo.src = url;
    photo.alt = mbComboLabel(combo);
    photo.classList.add("is-visible");
  }
}

function mbBuildTileGrid(offer, unitCount) {
  const combos = MB_COMBOS[unitCount];
  if (!combos) return null;

  const grid = document.createElement("div");
  grid.className = "mb-combo-grid";
  grid.setAttribute("data-mb-combo-units", String(unitCount));

  combos.forEach((combo, index) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "mb-combo-tile";
    btn.setAttribute("aria-pressed", index === 0 ? "true" : "false");
    btn.setAttribute("title", mbComboLabel(combo));

    const sw = document.createElement("span");
    sw.className = "mb-combo-swatch";
    sw.setAttribute("aria-hidden", "true");
    Array.from(new Set(combo)).forEach(name => {
      const part = document.createElement("i");
      part.style.background = MB_COLOURS[name] || "#CCC";
      sw.appendChild(part);
    });

    const label = document.createElement("span");
    label.className = "mb-combo-label";
    label.textContent = mbComboLabel(combo);

    btn.appendChild(sw);
    btn.appendChild(label);

    btn.addEventListener("click", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isUpdating) return;

      mbLockScroll(900);

      grid.querySelectorAll(".mb-combo-tile").forEach(t => {
        t.setAttribute("aria-pressed", String(t === btn));
      });

      mbShowComboPhoto(offer, combo);

      isUpdating = true;
      startHidingListboxes();
      try {
        await mbApplyCombo(offer, combo);
      } finally {
        stopHidingListboxes();
        isUpdating = false;
      }
    });

    grid.appendChild(btn);
  });

  return grid;
}

function mbSyncSwatchSize() {
  const plain = document.querySelector(
    ".moonbundle-option-wrapper:not(.mb-combo-mode) .moonbundle-variant-row .moonbundle-option-selector"
  );
  if (!plain) return;

  const sample = plain.querySelector('button, .moonbundle-swatch, [role="radio"]');
  if (!sample) return;

  const rect = sample.getBoundingClientRect();
  if (!rect.width || rect.width < 8) return;

  const radius = getComputedStyle(sample).borderRadius;

  document.documentElement.style.setProperty("--mb-sw-size", Math.round(rect.width) + "px");
  if (radius && radius !== "0px") {
    document.documentElement.style.setProperty("--mb-sw-radius", radius);
  }
}

function mbInjectComboTiles(offer) {
  if (offer.querySelector(".mb-combo-block")) return;

  const rows = getVariantRowsFromOffer(offer);
  if (!rows.length || !MB_COMBOS[rows.length]) return;

  const variantsBox = offer.querySelector(".moonbundle-variants-box");
  if (!variantsBox) return;

  const grid = mbBuildTileGrid(offer, rows.length);
  if (!grid) return;

  const block = document.createElement("div");
  block.className = "mb-combo-block";

  const photo = document.createElement("img");
  photo.className = "mb-combo-photo";
  photo.loading = "lazy";
  photo.decoding = "async";
  photo.alt = "";

  const heading = document.createElement("p");
  heading.className = "mb-combo-heading";
  heading.textContent = "Couleur";

  block.appendChild(photo);
  block.appendChild(heading);
  block.appendChild(grid);

  variantsBox.insertBefore(block, variantsBox.firstChild);
  offer.classList.add("mb-combo-mode");

  const combos = MB_COMBOS[rows.length];
  mbPreloadComboImages(combos);
}

function initGlobalBraSelectors() {
  injectStyles();
  mbInjectComboStyles();
  mbQuizInjectStyles();
  injectSizeGuideModal();
  mbQuizInjectTrigger();

  mbSyncSwatchSize();

  document.querySelectorAll(".moonbundle-option-wrapper").forEach(offer => {
    injectGlobalSelectorIntoOffer(offer);
    moveAllSizeSelectorsIntoBox(offer);
    mbInjectComboTiles(offer);
  });

  /* Une offre que Moon Bundle vient de (re)construire repart de zéro :
     si la cliente a déjà choisi une taille (quiz ou à la main), on la
     lui remet, sans qu'elle ait à refaire le quiz. */
  mbQuizReapplyToFreshOffers();
}

initGlobalBraSelectors();

const observer = new MutationObserver(() => {
  initGlobalBraSelectors();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


/* ============================================================
   Celyssia — « Trouvez votre taille parfaite »
   Quiz de taille en 4 questions.

   À COLLER dans le Custom JavaScript de Moon Bundle,
   APRÈS tout le code existant (tout à la fin du champ).

   Réutilise BRA_SIZE_MAP, BAND_OPTIONS et CUP_OPTIONS
   déclarés en haut du fichier.
   ============================================================ */

const MB_QUIZ_STATE = {
  band: "",
  cup: "",
  cupFit: "",
  bandFit: "",
  hooks: "",
  step: 1
};

/* ---------- logique de correction ---------- */

function mbQuizResolveSize() {
  const bandIdx = BAND_OPTIONS.indexOf(MB_QUIZ_STATE.band);
  const cupIdx = CUP_OPTIONS.indexOf(MB_QUIZ_STATE.cup);
  if (bandIdx === -1 || cupIdx === -1) return null;

  /* Bande : rangée la plus serrée = la bande est déjà au maximum,
     donc trop large. Rangée la plus large = l'inverse. */
  let bandDelta = 0;
  if (MB_QUIZ_STATE.bandFit === "tight") bandDelta += 1;
  if (MB_QUIZ_STATE.bandFit === "loose") bandDelta -= 1;
  if (MB_QUIZ_STATE.hooks === "closest") bandDelta -= 1;
  if (MB_QUIZ_STATE.hooks === "farthest") bandDelta += 1;

  if (bandDelta > 1) bandDelta = 1;
  if (bandDelta < -1) bandDelta = -1;

  /* Taille sœur : une bande plus étroite demande un bonnet plus grand
     pour le même volume. */
  let cupDelta = -bandDelta;
  if (MB_QUIZ_STATE.cupFit === "small") cupDelta += 1;
  if (MB_QUIZ_STATE.cupFit === "big") cupDelta -= 1;

  let newBandIdx = bandIdx + bandDelta;
  let newCupIdx = cupIdx + cupDelta;

  if (newBandIdx < 0) newBandIdx = 0;
  if (newBandIdx > BAND_OPTIONS.length - 1) newBandIdx = BAND_OPTIONS.length - 1;
  if (newCupIdx < 0) newCupIdx = 0;
  if (newCupIdx > CUP_OPTIONS.length - 1) newCupIdx = CUP_OPTIONS.length - 1;

  const band = BAND_OPTIONS[newBandIdx];
  const cup = CUP_OPTIONS[newCupIdx];

  /* Si la case n'existe pas au tableau, on suit le sens du produit
     (MB_PRODUCT.rounding) : "up" = on monte le bonnet d'abord,
     "down" = on descend d'abord. L'autre sens sert de second recours,
     pour ne jamais laisser la cliente sur « aucune correspondance ». */
  let shapelift = BRA_SIZE_MAP[band + cup];
  let resolvedCup = cup;

  const dir = MB_PRODUCT.rounding === "down" ? -1 : 1;

  for (let i = newCupIdx + dir; i >= 0 && i < CUP_OPTIONS.length && !shapelift; i += dir) {
    shapelift = BRA_SIZE_MAP[band + CUP_OPTIONS[i]];
    if (shapelift) resolvedCup = CUP_OPTIONS[i];
  }

  for (let i = newCupIdx - dir; i >= 0 && i < CUP_OPTIONS.length && !shapelift; i -= dir) {
    shapelift = BRA_SIZE_MAP[band + CUP_OPTIONS[i]];
    if (shapelift) resolvedCup = CUP_OPTIONS[i];
  }

  /* La taille affichée doit exister au guide : si la cliente la
     vérifie, elle ne doit pas tomber sur une case vide. */
  const cupAdjusted = resolvedCup !== cup;
  cupDelta = CUP_OPTIONS.indexOf(resolvedCup) - cupIdx;

  return {
    band: band,
    cup: resolvedCup,
    shapelift: shapelift || "",
    bandDelta: bandDelta,
    cupDelta: cupDelta,
    cupAdjusted: cupAdjusted,
    originalBand: MB_QUIZ_STATE.band,
    originalCup: MB_QUIZ_STATE.cup
  };
}

function mbQuizReasons(result) {
  const out = [];

  /* Les textes commencent en minuscule : ils suivent un deux-points. */

  if (result.bandDelta !== 0) {
    let why;
    if (result.bandDelta < 0) {
      why = MB_QUIZ_STATE.hooks === "closest"
        ? "vous le portez déjà sur la rangée la plus serrée. La bande ne peut plus se resserrer, et elle se détendra encore avec le temps."
        : "vous nous avez dit qu’elle remonte dans le dos.";
    } else {
      why = MB_QUIZ_STATE.bandFit === "tight"
        ? "vous nous avez dit qu’elle serre trop."
        : "vous l’attachez déjà sur la rangée la plus large, il ne reste plus de marge.";
    }
    out.push({
      label: "Tour de dos " + result.originalBand + " \u2192 " + result.band,
      text: why
    });
  }

  if (result.cupDelta !== 0 || result.cupAdjusted) {
    let why;
    if (result.cupAdjusted) {
      why = "ce bonnet n’existe pas sur ce tour de dos dans notre gamme, nous prenons le plus proche du guide.";
    } else if (MB_QUIZ_STATE.cupFit === "small") {
      why = "vous nous avez dit que la poitrine débordait.";
    } else if (MB_QUIZ_STATE.cupFit === "big") {
      why = "vous nous avez dit que le bonnet bâillait.";
    } else if (result.bandDelta < 0) {
      why = "une bande plus étroite demande un bonnet plus grand, à volume égal. Votre poitrine ne change pas, c’est la structure qui se resserre.";
    } else {
      why = "une bande plus large demande un bonnet plus petit, à volume égal. Votre poitrine ne change pas, c’est la structure qui s’élargit.";
    }
    out.push({
      label: "Bonnet " + result.originalCup + " \u2192 " + result.cup,
      text: why
    });
  }

  if (!out.length) {
    out.push({
      label: "Taille confirmée",
      text: "votre soutien-gorge actuel vous va bien, nous gardons la même correspondance."
    });
  }

  return out;
}

/* ---------- interface ---------- */

function mbQuizInjectStyles() {
  if (document.getElementById("mb-quiz-styles")) return;

  const style = document.createElement("style");
  style.id = "mb-quiz-styles";
  style.textContent = `
    .mb-quiz-open{
      background:none;border:0;padding:0;margin:0;
      font-size:13px;font-weight:600;color:#111;
      text-decoration:underline;cursor:pointer;line-height:1.2;
    }
    .mb-quiz-bar{
      display:flex;justify-content:space-between;align-items:center;
      gap:12px;margin:0 0 14px;padding:0 2px;
    }
    .mb-quiz-bar .mb-quiz-open{font-size:14px;}
    .mb-quiz-bar .mb-quiz-guide{font-weight:500;color:#4A342C;}
    .mb-quiz-modal{position:fixed;inset:0;display:none;z-index:100000;}
    .mb-quiz-modal.active{display:block;}
    .mb-quiz-overlay{position:absolute;inset:0;background:rgba(0,0,0,.55);}
    .mb-quiz-box{
      position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);
      width:92%;max-width:430px;max-height:88vh;overflow-y:auto;
      background:#FBF9F7;border-radius:16px;padding:22px 20px 20px;
      box-sizing:border-box;
      font-family:inherit;color:#1C1310;
    }
    .mb-quiz-steps{display:flex;gap:5px;margin-bottom:16px;}
    .mb-quiz-steps span{flex:1;height:3px;border-radius:2px;background:#E2D8D1;}
    .mb-quiz-steps span.done{background:#1C1310;}
    .mb-quiz-close{
      position:absolute;top:14px;right:14px;width:30px;height:30px;
      border:0;border-radius:999px;background:none;color:#6B5A52;
      font-size:22px;line-height:1;cursor:pointer;
    }
    .mb-quiz-count{font-size:12px;color:#8A7168;margin:0 0 6px;}
    .mb-quiz-q{font-size:21px;font-weight:700;line-height:1.25;margin:0 0 6px;}
    .mb-quiz-sub{font-size:13.5px;color:#6B5A52;margin:0 0 16px;line-height:1.4;}
    .mb-quiz-label{font-size:12px;color:#6B5A52;margin:0 0 7px;}
    .mb-quiz-grid{display:grid;gap:7px;margin-bottom:16px;}
    .mb-quiz-grid.bands{grid-template-columns:repeat(6,1fr);}
    .mb-quiz-grid.cups{grid-template-columns:repeat(6,1fr);}
    .mb-quiz-chip{
      appearance:none;border:1px solid #DED5CE;background:#fff;
      border-radius:9px;padding:10px 2px;font:inherit;font-size:13px;
      cursor:pointer;color:#1C1310;transition:background .12s,border-color .12s;
    }
    .mb-quiz-chip[aria-pressed="true"]{background:#1C1310;border-color:#1C1310;color:#fff;font-weight:600;}
    .mb-quiz-opt{
      display:flex;gap:11px;align-items:flex-start;width:100%;text-align:left;
      border:1px solid #DED5CE;background:#fff;border-radius:11px;
      padding:13px 14px;margin-bottom:8px;cursor:pointer;font:inherit;
    }
    .mb-quiz-opt[aria-pressed="true"]{border-color:#1C1310;border-width:2px;padding:12px 13px;}
    .mb-quiz-dot{
      flex:0 0 auto;width:17px;height:17px;border-radius:50%;
      border:1.5px solid #C4B7AE;margin-top:2px;position:relative;
    }
    .mb-quiz-opt[aria-pressed="true"] .mb-quiz-dot{border-color:#1C1310;}
    .mb-quiz-opt[aria-pressed="true"] .mb-quiz-dot::after{
      content:"";position:absolute;inset:3px;border-radius:50%;background:#1C1310;
    }
    .mb-quiz-opt b{display:block;font-size:14.5px;font-weight:700;margin-bottom:2px;}
    .mb-quiz-opt span.d{display:block;font-size:12.5px;color:#6B5A52;line-height:1.35;}
    .mb-quiz-nav{display:flex;align-items:center;gap:12px;margin-top:16px;}
    .mb-quiz-back{
      background:none;border:0;padding:6px 2px;font:inherit;font-size:13.5px;
      color:#6B5A52;cursor:pointer;
    }
    .mb-quiz-next{
      flex:1;appearance:none;border:0;border-radius:10px;
      background:#1C1310;color:#fff;font:inherit;font-size:15px;font-weight:600;
      padding:14px;cursor:pointer;
    }
    .mb-quiz-next[disabled]{background:#D8CCC4;color:#fff;cursor:default;}
    .mb-quiz-result{text-align:center;}
    .mb-quiz-result .cap{font-size:14px;color:#6B5A52;margin:0 0 14px;}
    .mb-quiz-size{
      border:1px dashed #C4B7AE;border-radius:10px;
      padding:22px 12px;margin:0 auto 14px;max-width:270px;background:#fff;
    }
    .mb-quiz-size .brand{font-size:12.5px;color:#8A7168;margin:0 0 8px;}
    .mb-quiz-size .val{font-size:46px;font-weight:700;line-height:1;margin:0;letter-spacing:-.01em;}
    .mb-quiz-size .garment{font-size:13px;color:#6B5A52;margin:10px 0 0;}
    .mb-quiz-size .garment b{color:#1C1310;font-weight:700;}
    .mb-quiz-result .spec{font-size:13.5px;color:#6B5A52;margin:0;}
    .mb-quiz-result .spec b{color:#1C1310;font-weight:700;}
    .mb-quiz-why{
      text-align:left;border-top:1px solid #E7DDD6;
      margin-top:18px;padding-top:16px;
    }
    .mb-quiz-why h4{font-size:14px;color:#6B5A52;font-weight:500;margin:0 0 12px;}
    .mb-quiz-why ul{list-style:none;margin:0;padding:0;}
    .mb-quiz-why li{
      position:relative;padding-left:16px;margin:0 0 12px;
      font-size:13.5px;line-height:1.5;color:#4A342C;
    }
    .mb-quiz-why li::before{
      content:"";position:absolute;left:0;top:10px;
      width:8px;height:1.5px;background:#A8968C;
    }
    .mb-quiz-why li b{color:#1C1310;font-weight:700;}
    .mb-quiz-why .rule{
      margin:14px 0 0;font-size:12.5px;color:#8A7168;font-style:italic;
    }
    .mb-quiz-result .mb-quiz-next{width:100%;margin-top:18px;}
    .mb-quiz-restart{
      display:block;margin:14px auto 0;background:none;border:0;
      font:inherit;font-size:13.5px;color:#6B5A52;text-decoration:underline;cursor:pointer;
    }
    @media (max-width:400px){
      .mb-quiz-grid.cups{grid-template-columns:repeat(4,1fr);}
      .mb-quiz-grid.bands{grid-template-columns:repeat(5,1fr);}
      .mb-quiz-q{font-size:19px;}
    }
  `;
  document.head.appendChild(style);
}

function mbQuizModal() {
  let modal = document.getElementById("mb-quiz-modal");
  if (modal) return modal;

  modal = document.createElement("div");
  modal.id = "mb-quiz-modal";
  modal.className = "mb-quiz-modal";
  modal.innerHTML =
    '<div class="mb-quiz-overlay"></div>' +
    '<div class="mb-quiz-box" role="dialog" aria-modal="true">' +
      '<button type="button" class="mb-quiz-close" aria-label="Fermer">&times;</button>' +
      '<div class="mb-quiz-body"></div>' +
    '</div>';
  document.body.appendChild(modal);

  modal.querySelector(".mb-quiz-close").addEventListener("click", mbQuizClose);
  modal.querySelector(".mb-quiz-overlay").addEventListener("click", mbQuizClose);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") mbQuizClose();
  });

  return modal;
}

function mbQuizClose() {
  const modal = document.getElementById("mb-quiz-modal");
  if (modal) modal.classList.remove("active");
}

function mbQuizOpen() {
  mbQuizInjectStyles();
  const modal = mbQuizModal();
  MB_QUIZ_STATE.step = 1;
  modal.classList.add("active");
  mbQuizRender();
}

function mbQuizStepsBar(step) {
  let out = '<div class="mb-quiz-steps">';
  for (let i = 1; i <= 4; i++) {
    out += '<span class="' + (i <= step ? "done" : "") + '"></span>';
  }
  return out + "</div>";
}

function mbQuizRender() {
  const modal = mbQuizModal();
  const body = modal.querySelector(".mb-quiz-body");
  const s = MB_QUIZ_STATE;

  if (s.step === 1) {
    body.innerHTML =
      mbQuizStepsBar(1) +
      '<p class="mb-quiz-count">Question 1 / 4</p>' +
      '<p class="mb-quiz-q">Quelle taille portez-vous actuellement&nbsp;?</p>' +
      '<p class="mb-quiz-sub">Pensez au soutien-gorge dans lequel vous êtes le plus à l’aise.</p>' +
      '<p class="mb-quiz-label">Tour de dos</p>' +
      '<div class="mb-quiz-grid bands">' +
        BAND_OPTIONS.map(function (v) {
          return '<button type="button" class="mb-quiz-chip" data-band="' + v + '" aria-pressed="' + (s.band === v) + '">' + v + '</button>';
        }).join("") +
      '</div>' +
      '<p class="mb-quiz-label">Bonnet</p>' +
      '<div class="mb-quiz-grid cups">' +
        CUP_OPTIONS.map(function (v) {
          return '<button type="button" class="mb-quiz-chip" data-cup="' + v + '" aria-pressed="' + (s.cup === v) + '">' + v + '</button>';
        }).join("") +
      '</div>' +
      '<div class="mb-quiz-nav"><button type="button" class="mb-quiz-next" data-next ' +
        (s.band && s.cup ? "" : "disabled") + '>Continuer</button></div>';
  }

  if (s.step === 2) {
    body.innerHTML =
      mbQuizStepsBar(2) +
      '<p class="mb-quiz-count">Question 2 / 4</p>' +
      '<p class="mb-quiz-q">Comment le bonnet vous va-t-il&nbsp;?</p>' +
      '<p class="mb-quiz-sub">Toujours le même soutien-gorge qu’à la question 1.</p>' +
      mbQuizOption("cupFit", "small", "Trop petit", "La poitrine déborde par le haut ou sur les côtés.") +
      mbQuizOption("cupFit", "perfect", "Parfait", "Ni vide, ni débordement.") +
      mbQuizOption("cupFit", "big", "Trop grand", "Le bonnet bâille ou fait des plis.") +
      mbQuizNav(s.cupFit);
  }

  if (s.step === 3) {
    body.innerHTML =
      mbQuizStepsBar(3) +
      '<p class="mb-quiz-count">Question 3 / 4</p>' +
      '<p class="mb-quiz-q">Comment la bande sous la poitrine vous tient-elle&nbsp;?</p>' +
      '<p class="mb-quiz-sub">C’est elle qui assure l’essentiel du maintien.</p>' +
      mbQuizOption("bandFit", "tight", "Trop serrée", "Elle marque la peau ou comprime.") +
      mbQuizOption("bandFit", "perfect", "Parfaite", "Elle reste bien horizontale, sans bouger.") +
      mbQuizOption("bandFit", "loose", "Trop lâche", "Elle remonte dans le dos.") +
      mbQuizNav(s.bandFit);
  }

  if (s.step === 4) {
    body.innerHTML =
      mbQuizStepsBar(4) +
      '<p class="mb-quiz-count">Question 4 / 4</p>' +
      '<p class="mb-quiz-q">Sur quelle rangée d’agrafes l’attachez-vous&nbsp;?</p>' +
      '<p class="mb-quiz-sub">Cela nous dit s’il vous reste de la marge.</p>' +
      mbQuizOption("hooks", "closest", "La plus serrée", "Celle qui serre le plus.") +
      mbQuizOption("hooks", "medium", "Au milieu", "La rangée du milieu.") +
      mbQuizOption("hooks", "farthest", "La plus large", "Celle qui serre le moins.") +
      mbQuizNav(s.hooks, "Voir ma taille");
  }

  if (s.step === 5) {
    const result = mbQuizResolveSize();

    if (!result || !result.shapelift) {
      body.innerHTML =
        '<div class="mb-quiz-result"><p class="mb-quiz-q">Aucune correspondance trouvée</p>' +
        '<p class="mb-quiz-sub">Consultez le guide des tailles ou écrivez-nous, nous trouverons votre taille avec vous.</p>' +
        '<button type="button" class="mb-quiz-restart" data-restart>Recommencer</button></div>';
      mbQuizBind(body);
      return;
    }

    body.innerHTML =
      '<div class="mb-quiz-result">' +
        '<p class="cap">Votre taille recommandée</p>' +
        '<div class="mb-quiz-size">' +
          '<p class="brand">Celyssia</p>' +
          '<p class="val">' + result.band + result.cup + '</p>' +
          '<p class="garment">Taille ' + MB_PRODUCT.label + '&nbsp;: <b>' + result.shapelift + '</b></p>' +
        '</div>' +
        '<p class="spec">Vous nous avez indiqué du <b>' + result.originalBand + result.originalCup + '</b>.</p>' +
        '<div class="mb-quiz-why"><h4>Pourquoi cette taille&nbsp;?</h4><ul>' +
          mbQuizReasons(result).map(function (r) {
            return '<li><b>' + r.label + '</b>&nbsp;: ' + r.text + '</li>';
          }).join("") +
        '</ul>' +
        (MB_PRODUCT.roundingText ? '<p class="rule">' + MB_PRODUCT.roundingText + '</p>' : '') +
        '</div>' +
        '<button type="button" class="mb-quiz-next" data-apply>Choisir cette taille</button>' +
        '<button type="button" class="mb-quiz-restart" data-restart>Recommencer</button>' +
      '</div>';
  }

  mbQuizBind(body);
}

function mbQuizOption(field, value, title, desc) {
  const on = MB_QUIZ_STATE[field] === value;
  return '<button type="button" class="mb-quiz-opt" data-field="' + field + '" data-value="' + value + '" aria-pressed="' + on + '">' +
    '<span class="mb-quiz-dot"></span><span><b>' + title + '</b>' +
    (desc ? '<span class="d">' + desc + '</span>' : "") + '</span></button>';
}

function mbQuizNav(value, label) {
  return '<div class="mb-quiz-nav">' +
    '<button type="button" class="mb-quiz-back" data-back>Retour</button>' +
    '<button type="button" class="mb-quiz-next" data-next ' + (value ? "" : "disabled") + '>' +
    (label || "Continuer") + '</button></div>';
}

function mbQuizBind(body) {
  body.querySelectorAll("[data-band]").forEach(function (el) {
    el.addEventListener("click", function () {
      MB_QUIZ_STATE.band = el.getAttribute("data-band");
      mbQuizRender();
    });
  });

  body.querySelectorAll("[data-cup]").forEach(function (el) {
    el.addEventListener("click", function () {
      MB_QUIZ_STATE.cup = el.getAttribute("data-cup");
      mbQuizRender();
    });
  });

  body.querySelectorAll("[data-field]").forEach(function (el) {
    el.addEventListener("click", function () {
      MB_QUIZ_STATE[el.getAttribute("data-field")] = el.getAttribute("data-value");
      mbQuizRender();
    });
  });

  const next = body.querySelector("[data-next]");
  if (next) next.addEventListener("click", function () {
    MB_QUIZ_STATE.step += 1;
    mbQuizRender();
  });

  const back = body.querySelector("[data-back]");
  if (back) back.addEventListener("click", function () {
    MB_QUIZ_STATE.step -= 1;
    mbQuizRender();
  });

  const restart = body.querySelector("[data-restart]");
  if (restart) restart.addEventListener("click", function () {
    MB_QUIZ_STATE.band = "";
    MB_QUIZ_STATE.cup = "";
    MB_QUIZ_STATE.cupFit = "";
    MB_QUIZ_STATE.bandFit = "";
    MB_QUIZ_STATE.hooks = "";
    MB_QUIZ_STATE.step = 1;
    mbQuizRender();
  });

  const apply = body.querySelector("[data-apply]");
  if (apply) apply.addEventListener("click", function () {
    const result = mbQuizResolveSize();
    mbQuizClose();
    if (result) mbQuizApply(result);
  });
}

/* ---------- application au sélecteur existant ---------- */

/* Une offre est « visible » si elle occupe de la place à l'écran.
   Moon Bundle replie les offres non sélectionnées : leur liste
   déroulante ne s'ouvre pas, on ne peut donc pas les piloter. */
function mbOfferIsVisible(offer) {
  if (!offer || !offer.isConnected) return false;
  const rect = offer.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

/* Remplit Tour de dos / Bonnet dans le panneau d'une offre, puis
   pousse la taille produit correspondante (BRA_SIZE_MAP) dans
   chaque liste Moon Bundle de cette offre. Renvoie true si chaque
   exemplaire affiche bien la bonne lettre à la fin. */
async function mbQuizApplyToUI(ui, band, cup) {
  const bandSelect = ui.querySelector(".mb-global-band");
  const cupSelect = ui.querySelector(".mb-global-cup");
  const errorEl = ui.querySelector(".mb-global-bra-error-wrap");
  const offer = ui.closest(".moonbundle-option-wrapper");
  if (!bandSelect || !cupSelect || !offer) return false;

  bandSelect.value = band;
  cupSelect.value = cup;

  /* Si un autre passage est encore en cours (choix manuel juste
     avant, ou l'offre précédente), on attend qu'il se termine au
     lieu d'être rejeté par le verrou isUpdating. */
  await waitFor(function () { return !isUpdating; }, 4000, 40);

  let ok = await applyMappedSizeToOffer(offer, band, cup, errorEl);

  /* Vérification indépendante : on relit ce que Moon Bundle affiche
     réellement, on ne se fie pas au retour seul. */
  const mapped = normalizeText(BRA_SIZE_MAP[band + cup] || "");
  const check = function () {
    const dropdowns = Array.from(
      offer.querySelectorAll(".mb-recommended-size-slot .moonbundle-custom-dropdown")
    );
    return dropdowns.length > 0 &&
      dropdowns.every(function (d) { return readMoonbundleDropdownValue(d) === mapped; });
  };

  if (!check()) {
    /* Moon Bundle a pu reconstruire la ligne après notre passage :
       on laisse retomber, puis on refait un tour complet. */
    await wait(350);
    await waitFor(function () { return !isUpdating; }, 4000, 40);
    ok = await applyMappedSizeToOffer(offer, band, cup, errorEl);
  }

  return ok && check();
}

async function mbQuizApply(result) {
  if (!result || !result.band || !result.cup) return;

  MB_QUIZ_APPLIED.band = result.band;
  MB_QUIZ_APPLIED.cup = result.cup;

  const uis = Array.from(document.querySelectorAll(".mb-global-bra-ui"));

  /* L'offre ouverte d'abord : c'est celle que la cliente regarde.
     Les offres repliées sont traitées ensuite si elles se laissent
     piloter, sinon elles seront remises à jour par
     mbQuizReapplyToFreshOffers quand Moon Bundle les affichera. */
  const visible = uis.filter(function (ui) {
    return mbOfferIsVisible(ui.closest(".moonbundle-option-wrapper"));
  });
  const hidden = uis.filter(function (ui) { return visible.indexOf(ui) === -1; });

  for (const ui of visible) {
    await mbQuizApplyToUI(ui, result.band, result.cup);
  }

  for (const ui of hidden) {
    const bandSelect = ui.querySelector(".mb-global-band");
    const cupSelect = ui.querySelector(".mb-global-cup");
    if (bandSelect) bandSelect.value = result.band;
    if (cupSelect) cupSelect.value = result.cup;
    ui.setAttribute("data-mb-pending", "1");
  }
}

/* Appelé à chaque rendu de Moon Bundle. Toute offre visible dont le
   panneau n'a pas encore reçu la taille choisie (nouvelle offre
   reconstruite, ou offre repliée au moment du quiz) la reçoit ici,
   une seule fois. */
let mbReapplyRunning = false;

async function mbQuizReapplyToFreshOffers() {
  if (!MB_QUIZ_APPLIED.band || !MB_QUIZ_APPLIED.cup) return;
  if (mbReapplyRunning || isUpdating) return;

  const uis = Array.from(document.querySelectorAll(".mb-global-bra-ui")).filter(function (ui) {
    const bandSelect = ui.querySelector(".mb-global-band");
    const cupSelect = ui.querySelector(".mb-global-cup");
    const fresh = bandSelect && cupSelect && (!bandSelect.value || !cupSelect.value);
    const pending = ui.getAttribute("data-mb-pending") === "1";
    return (fresh || pending) && mbOfferIsVisible(ui.closest(".moonbundle-option-wrapper"));
  });

  if (!uis.length) return;

  mbReapplyRunning = true;
  try {
    for (const ui of uis) {
      ui.removeAttribute("data-mb-pending");
      await mbQuizApplyToUI(ui, MB_QUIZ_APPLIED.band, MB_QUIZ_APPLIED.cup);
    }
  } finally {
    mbReapplyRunning = false;
  }
}

/* ---------- point d'entrée ---------- */

/* Remonte jusqu'au conteneur Moon Bundle le plus externe. */
function mbFindBundleRoot() {
  const offers = document.querySelectorAll(".moonbundle-option-wrapper");
  if (!offers.length) return null;

  let root = offers[0];
  while (
    root.parentElement &&
    typeof root.parentElement.className === "string" &&
    /moonbundle/i.test(root.parentElement.className)
  ) {
    root = root.parentElement;
  }

  return root;
}

/* Barre placée AU-DESSUS du widget Moon Bundle :
   le quiz à gauche, le guide des tailles à droite. */
function mbQuizInjectTrigger() {
  mbQuizInjectStyles();

  if (document.querySelector(".mb-quiz-bar")) return;

  const root = mbFindBundleRoot();
  if (!root || !root.parentElement) return;

  const bar = document.createElement("div");
  bar.className = "mb-quiz-bar";

  const quiz = document.createElement("button");
  quiz.type = "button";
  quiz.className = "mb-quiz-open";
  quiz.textContent = "Trouvez votre taille parfaite";
  quiz.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    mbQuizOpen();
  });

  const guide = document.createElement("button");
  guide.type = "button";
  guide.className = "mb-quiz-open mb-quiz-guide";
  guide.textContent = "Guide des tailles";
  guide.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    injectSizeGuideModal();
    openSizeGuideModal(e);
  });

  bar.appendChild(quiz);
  bar.appendChild(guide);

  root.parentElement.insertBefore(bar, root);
}

/* mbQuizInjectTrigger() est déjà appelé depuis initGlobalBraSelectors,
   qui est relancé par l'observer à chaque rendu de Moon Bundle. */